"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialize = void 0;
var tslib_1 = require("tslib");
var initScript_1 = require("./initScript");
// eslint-disable-next-line @typescript-eslint/naming-convention
var URLs = {
    production: 'https://cdn.chargeafter.com/web/v2/chargeafter.min.js',
    qa: 'https://cdn-qa.ca-dev.co/web/v2/chargeafter.min.js',
    sandbox: 'https://cdn-sandbox.ca-dev.co/web/v2/chargeafter.min.js',
    demo: 'https://cdn-demo.ca-dev.co/web/v2/chargeafter.min.js',
    develop: 'https://cdn-develop.ca-dev.co/web/v2/chargeafter.min.js',
    autoqa: 'https://cdn-autoqa.ca-dev.co/web/v2/chargeafter.min.js',
    uat: 'https://cdn-uat.ca-dev.co/web/v2/chargeafter.min.js',
};
var initialize = function (caConfig, env) {
    if (env === void 0) { env = 'production'; }
    return tslib_1.__awaiter(void 0, void 0, void 0, function () {
        var envUrl, document, resolveCAObject, rejectCAObject, chargeafter, onLoadedFn;
        var _a;
        return tslib_1.__generator(this, function (_b) {
            envUrl = URLs[env];
            document = window.document;
            if (document.getElementById(initScript_1.checkoutId) && window.ChargeAfter) {
                (_a = caConfig.onLoaded) === null || _a === void 0 ? void 0 : _a.call(caConfig);
                return [2 /*return*/, window.ChargeAfter];
            }
            window.caConfig = caConfig;
            window.ChargeAfter = tslib_1.__assign(tslib_1.__assign({}, (window.ChargeAfter || {})), { cfg: caConfig });
            chargeafter = new Promise(function (resolve, reject) {
                resolveCAObject = resolve;
                rejectCAObject = reject;
            });
            onLoadedFn = function () { return tslib_1.__awaiter(void 0, void 0, void 0, function () {
                var _a;
                return tslib_1.__generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            if (!window.ChargeAfter) return [3 /*break*/, 2];
                            return [4 /*yield*/, ((_a = window.ChargeAfter) === null || _a === void 0 ? void 0 : _a.init(caConfig))];
                        case 1:
                            _b.sent();
                            resolveCAObject(window.ChargeAfter);
                            return [3 /*break*/, 3];
                        case 2:
                            rejectCAObject(new Error('ChargeAfter not initialized'));
                            _b.label = 3;
                        case 3: return [2 /*return*/];
                    }
                });
            }); };
            (0, initScript_1.initScript)(envUrl, onLoadedFn);
            return [2 /*return*/, chargeafter];
        });
    });
};
exports.initialize = initialize;
